export const ASSET_UPLOAD_URL = '/v3/scm/asset-management/raw-assets';
